export interface ICustomIndex {
  customIndex?: number;
}
